<template>
  <spinner-container :loading="localLoading">
   <back-btn/>

    <v-row justify="center">
      <v-col cols="12" md="6">
        <da-form :da="da" @emitDaData="updateDA" />
      </v-col>
    </v-row>
  </spinner-container>
</template>

<script>
import DaForm from "@/components/da/DaForm";
import { mapState } from "vuex";
import SpinnerContainer from "@/components/container/SpinnerContainer";
import BackBtn from '@/components/navigation/BackBtn.vue';

export default {
  components: {
    DaForm,
    SpinnerContainer,
    BackBtn,
  },
  data: () => ({}),
  computed: {
    ...mapState("Da", ["da"]),
    ...mapState("Loading", ["localLoading"]),
  },
  methods: {
    updateDA(payload) {
      this.$store.dispatch("Da/updateDA", payload).then(() => {
        this.$router.push({ name: "da" });
      });
    },
  },
  created() {
    this.$store.dispatch("Loading/changeLocalLoading");
    this.$store.dispatch("Da/getDA", this.$route.params.id).then(() => {
      this.$store.dispatch("Loading/changeLocalLoading");
    });
  },
};
</script>
